export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/education.4702213.svg";